<template>
  <div class="overlay-editor-wrapper">
    <div class="panel-top">
      <div class="panel-top-name">{{ $static('lead-e.title', 'Редагування заявки') }}</div>
      <a href="javascript:void(0);" class="back_trigger" @click="close">
        <span class="icon icon-cross"></span>
      </a>
    </div>
    <div class="panel-middle">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label class="custom-label">Статус заявки</label><!--? добавить static-->
            <div class="selector-holder">
              <v-select id="input_sort" :options="leadStatusList" :searchable="false" :reduce="c => c.value"
                v-model="selected.status">
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M15.1528 8.22224C15.4213 8.49072 15.4213 8.92602 15.1528 9.19451L11.4861 12.8612C11.2177 13.1297 10.7824 13.1297 10.5139 12.8612L6.84721 9.19451C6.57872 8.92602 6.57872 8.49072 6.84721 8.22224C7.11569 7.95375 7.55099 7.95375 7.81948 8.22224L11 11.4028L14.1805 8.22224C14.449 7.95375 14.8843 7.95375 15.1528 8.22224Z"
                        fill="#212121" />
                    </svg>
                  </span>
                </template>
              </v-select>
            </div>
            <div v-if="selected.info?.orderId">{{ `З Замовлення #${selected.info.orderId}` }}</div>
          </div>
        </div>

      </div>
      <div class="panel-bordered panel order-total-info row " style="background-color:#ffffff">
        <div class="col order-total-info-col">
          <div class="custom-label">Номер заявки</div><!--? добавить static-->
          <div class="value">#{{ selected.id }}</div>
        </div>
        <div class="col order-total-info-col">
          <div class="custom-label">Час заявки</div><!--? добавить static-->
          <div class="value">{{ selected.created_at.toLocaleDateString() }} <span class="clock">{{
            selected.created_at.toLocaleTimeString() }}</span></div>
        </div>
        <div class="col order-total-info-col">
          <div class="custom-label">{{ $static('order-e.t6', 'Усього:') }}</div>
          <div class="value">{{ selected.total }} {{ $store.getters.symbol }}</div>
        </div>
        <div class="col order-total-info-col" v-if="selected?.info?.bonus_discount">
          <div class="custom-label">{{ $static('order-e.bns', 'Бонуси:') }}</div>
          <div class="value">{{ selected.info.bonus_discount }} {{ $store.getters.symbol }}</div>
          <button @click="bonusBack(selected.id)">Повернути бонуси</button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="custom-label">Позиція заявки</div><!--? добавить static-->
          <ul class="editor-order-list">
            <li class="order-list-item " v-for="(element, index) in selected.info.busked">
              <div class="product-card-top d-flex justify-content-between">
                <div class="product-card_main w-50">
                  <div class="product-card_img bg"
                    :style="{ 'background-image': $filters.backgroundImage(element.preview) }">
                  </div>
                  <div class="product-card__title editor_trigger">{{ element.title }}</div>
                </div>
                <div class="option-item price-item">
                  <div class="name">{{ $static('order-e.t8', 'Ціна:') }}</div>
                  <div class="value" v-if="element.old_price"><strike>{{ $filters.money(element.old_price) }}
                      {{ $store.getters.symbol }}</strike> = {{ $filters.money(element.price) }} {{
                        $store.getters.symbol }}
                  </div>
                  <div class="value" v-else>{{ $filters.money(element.price) }}</div>
                </div>
                <!--                <div class="option-item" v-if="element.count">-->
                <!--                  <div class="name">{{ $static('order-e.t9', 'К-сть:') }}</div>-->
                <!--                  <div class="value">{{ element.count }}</div>-->
                <!--                </div>-->

              </div>
              <div class="options-list">
                <div class="option-list-title">Параметри заявки:</div> <!--? добавить static-->
                <div class="option-list-holder">
                  <div class="option-item " v-for="(op, opIndex) in element.add" :key="opIndex">
                    <div class="name">{{ op.option }}:</div>
                    <div class="value">{{ op.name }} {{ $filters.money(op.price) }}{{ $store.getters.symbol }}</div>
                  </div>
                  <div class="option-item " v-for="(op, opIndex) in element.u_select" :key="opIndex">
                    <div class="name">{{ op.name }}:</div>
                    <div class="value">{{ op.item.name }} {{ $filters.money(op.item.price) }}{{ $store.getters.symbol }}
                    </div>
                  </div>
                </div>
              </div>

            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.e3', 'Ім\'я:') }}</label>
            <input type="text" class="form-control custom-input" v-model="selected.info.name" readonly>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.e2', 'email:') }}</label>
            <input type="text" class="form-control custom-input" v-model="selected.info.email" readonly>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.e1', 'Телефон:') }}</label>
            <input type="text" class="form-control custom-input" v-model="selected.info.phone" readonly>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label class="custom-label">Дата та час</label> <!--? добавить static-->
            <input type="text" class="form-control custom-input" v-model="dateString" readonly>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col">
          <div class="form-group">
            <label class="custom-label">{{ $static('order-e.e6', 'User ID:') }}</label>
            <div class="user-id-box d-flex align-items-center">
              <div class="input-holder">
                <div class="button-group d-flex">
                  <Popper arrow :content="$static('iconsbtn.delete', 'Видалити')" hover placement="top"
                    style="white-space: nowrap">
                    <button class="btn-icon btn-icon-transparent">
                      <span class="icon icon-cross"></span>
                    </button>
                  </Popper>
                  <Popper arrow :content="$static('iconsbtn.don', 'Виконано')" hover placement="top"
                    style="white-space: nowrap">
                    <button class="btn-icon btn-icon-transparent">
                      <span class="icon icon-double-check"></span>
                    </button>
                  </Popper>

                </div>
                <input type="text" class="rewrite-user-id form-control custom-input" placeholder="308653738">
              </div>
              <div class="default-holder">
                <div class="user-id-prev">
                  <!--                  <span class="avatar bg" style="background-image: url(images/avatar.png);"></span>-->
                  <span class="name" v-if="selected.user && selected.user.telegram">
                    {{ selected.user.telegram.id }} @{{ selected.user.telegram.username }}</span>
                </div>
                <!--                <div class="button-group d-flex">-->
                <!--                  <button class="btn-icon btn-icon-transparent">-->
                <!--                    <span class="icon icon-clipboard"></span>-->
                <!--                  </button>-->
                <!--                  <button class="btn-icon btn-icon-transparent user-edit-id">-->
                <!--                    <span class="icon icon-edit"></span>-->
                <!--                  </button>-->
                <!--                </div>-->
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <!-- На данный момент функционал оплаты для заявки скрыт в магазине, поэтому скрывается и здесь -->
          <!-- <div class="form-group">
            <label class="custom-label">Тип оплати</label>
            <input type="text" class="form-control custom-input" v-model="paymentTypeName" readonly>
          </div> -->
        </div>
      </div>

      <div class="row mb-2" v-for="(field, index) in fields" :key="index">
        <div class="col">
          <div class="custom-label">{{ field.manifest.name }}</div>
          <div class="image-fields" v-if="field.manifest.type === 'image'">
            <a target="_blank" v-for="(img, iIndex) in field.data" :href="img" :key="iIndex">
              <img :src="img">
            </a>
          </div>
        </div>
      </div>

      <!-- ! Кастомные поля модалки заявки -->
      <div class="row" v-if="selected.info.orderPageComment">
        <div class="col-6">
          <div class="custom-label">Додатковi поля</div><!--? добавить static-->
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label class="custom-label">Коментар</label><!--? добавить static-->
                <textarea class="form-control custom-input" readonly
                  v-model="selected.info.orderPageComment"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="(selected.info.fields?.length > 0)">
        <div class="col">
          <h3>Додатковi поля</h3><!--? добавить static-->

          <template v-for="(customField, customFieldIndex) in selected.info.fields"
            :key="'customField'+customFieldIndex">
            <!-- Текстовое или числовое поле -->
            <div class="row" v-if="(customField.manifest.type === 'text' || customField.manifest.type === 'number')">
              <div class="col">
                <div class="form-group">
                  <label class="custom-label">{{ customField?.manifest?.name || "Текстове поле"
                    }}</label><!--? добавить static-->
                  <textarea class="form-control custom-input" readonly v-model="customField.data"></textarea>
                </div>
              </div>
            </div>

            <!-- Поле изображения -->
            <!-- <template v-if="customField.manifest.type === 'image' && customField.data">
              <label class="custom-label">{{ customField?.manifest?.name || `Додаткове поле №${customFieldIndex}`
                }}</label>
              <div class="files-uploader default-files-uploader">
                <div class="uploader-previews">
                  <a data-fancybox="gallery" class="image bg" v-for="(requestImg, requestImgIndex) in
                    customField.data" :href="requestImg" :key="'requstImg' + requestImgIndex"
                    :style="{ backgroundImage: `url('${requestImg}')` }">
                    <div>{{ getFileName(requestImg) }}</div>
                  </a>
                </div>
              </div>
            </template> -->

            <!-- Поле файла -->
            <!-- <template v-if="customField.manifest.type === 'file' && customField.data">
              <label class="custom-label">{{ customField?.manifest?.name || `Додаткове поле №${customFieldIndex}`
                }}</label>
              <div class="files-uploader default-files-uploader">
                <div class="uploader-previews">
                  <button class="image bg" v-for="(requestImg, requestImgIndex) in customField.data"
                    @click="downloadServiceRequestFile(requestImg)" :key="'requstImg' + requestImgIndex"
                    :style="{ backgroundImage: `url('${requestImg}')` }">
                    
                    <div>{{ getFileName(requestImg) }}</div>
                  </button>
                </div>
              </div>
            </template> -->
            <template v-if="customField.manifest.type === 'file'">
              <label class="custom-label">{{ customField?.manifest?.name || `Додаткове поле №${customFieldIndex}`
                }}</label>

              <div class="files-uploader default-files-uploader lead-uploader">
                <div class="uploader-previews">
                  <div v-if="customField.data?.length === 0">Файли відсутні</div>
                  <div class="image bg" v-for="(requestImg, requestImgIndex) in customField.data"
                    :key="'requstImg' + requestImgIndex" :style="{
                      backgroundImage: isImageFile(requestImg) ? `url('${requestImg}')` : `url('/images/file_placeholder.png')`
                    }">
                    <!-- <img class="image bg" :src="requestImg" alt=""> -->
                    <!-- <div>{{ getFileName(requestImg) }}</div> -->
                    <div>
                      <Popper v-if="isImageFile(requestImg)" arrow content="Відкрити" hover placement="top"
                        style="white-space: nowrap">
                        <a data-fancybox="gallery" class="btn-icon btn-remove btn-small" :href="requestImg"
                          style="bottom: 3px;top: inherit;left: 3px;"><span
                            class="icon icon-right icon-trash-unfilled"></span></a>
                      </Popper>

                      <Popper v-if="!isImageFile(requestImg)" arrow content="Завантажити" hover placement="top"
                        style="white-space: nowrap">
                        <button class="btn-icon btn-remove btn-small" @click="downloadServiceRequestFile(requestImg)"
                          style="bottom: 3px;top: inherit;right: 3px;">
                          <span class="icon icon-right icon-trash-filled"></span>
                        </button>
                      </Popper>
                    </div>

                  </div>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>


      <template
        v-if="selected.utm_source || selected.utm_content || selected.utm_medium || selected.utm_term || selected.utm_campaign">
        <h3>UTM мітки</h3>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label class="custom-label">utm_source</label>
              <input type="text" class="form-control custom-input" v-model="selected.utm_source" disabled>
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label class="custom-label">utm_content</label>
              <input type="text" class="form-control custom-input" v-model="selected.utm_content" disabled>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label class="custom-label">utm_medium</label>
              <input type="text" class="form-control custom-input" v-model="selected.utm_medium" disabled>
            </div>
          </div>

          <div class="col">
            <div class="form-group">
              <label class="custom-label">utm_term</label>
              <input type="text" class="form-control custom-input" v-model="selected.utm_term" disabled>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label class="custom-label">utm_campaign</label>
              <input type="text" class="form-control custom-input" v-model="selected.utm_campaign" disabled>
            </div>
          </div>
          <div class="col"></div>
        </div>
      </template>
    </div>
    <!--    <div class="operational-buttons d-flex justify-content-end">-->
    <!--      <button class="btn-icon btn-icon-outline btn-medium">-->
    <!--        <span class="icon icon-print"></span>-->
    <!--      </button>-->
    <!--      <button class="waves-effect waves-light default-btn btn-green">-->
    <!--        <span class="text">Выслать счет</span>-->
    <!--      </button>-->
    <!--    </div>-->


    <div class="panel-bottom">
      <button class="transparent-btn default-btn back_trigger" @click="close">
        <span class="text">{{ $static('order-e.cancel', 'Скасувати') }}</span>
      </button>
      <button class=" default-btn btn-accent" @click="save">
        <span class="text">{{ $static('order-e.save', 'Зберегти зміни') }}</span>
      </button>
      <!--      <button class=" default-btn btn-red">-->
      <!--        <span class="text">{{$static('order-e.del', 'Удалить товар')}}</span>-->
      <!--      </button>-->
    </div>
  </div>
</template>
<script>
import api from '@/api'
import { nextTick } from 'vue'

export default {
  name: 'LeadEditItem',
  props: ['selected'],
  data() {
    return {
    }
  },
  mounted() {
    window.$('.lead-editor select.select-custom').selectpicker();
  },
  computed: {
    fields() {
      return this.selected?.info?.field ? this.selected.info.field : []
    },
    deliveryOptions() {
      return this.$store.getters.deliveryOptions
    },
    payments() {
      return this.$store.getters.payments
    },
    leadStatusList() {
      return this.$store.getters.leadStatusList
    },
    payStatusList() {
      return this.$store.getters.payStatusList
    },
    dateString() {
      if (!this.$props.selected || !this.$props.selected?.info || !this.$props.selected.info?.date) { return "" }
      // Опции для форматирования даты
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
      };

      return (new Date(this.$props.selected.info.date * 1000)).toLocaleDateString('uk-UA', options)
    },
    isCustomFieldsData() {
      return this.selected?.info?.fields.some(field => field.data);
    }
    // На данный момент функционал оплаты для заявки скрыт в магазине, поэтому скрывается и здесь
    // paymentTypeName() {
    //   if (this.selected.info && this.selected.info.paymentType && this.selected.info.paymentType.label) {
    //     return this.selected.info.paymentType.label
    //   }
    //   return "";
    // }
  },
  methods: {
    close() {
      window.$('body').removeClass('is-hidden');
      if (!window.$('body > .client-profile-editor').hasClass('active')) {
        window.$('.back-blur').removeClass('active');
      }
      window.$('body > .lead-editor.active').removeClass('active');

    },
    save() {
      let obj = Object.assign({}, this.selected);
      api.put('/api/lead', obj).then(response => response.data).then(data => {
        this.$emit('save', data);
      });

      window.$('body').removeClass('is-hidden');
      window.$('body > .active').removeClass('active');
    },

    downloadServiceRequestFile(fileUrl) {
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', '');
      // link.setAttribute('target', '_blank');
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    getFileName(url) {
      let temp = url.split('/').pop();

      // Проверяем, если длина строки больше 15 символов
      if (temp.length > 15) {
        // Обрезаем строку до 12 символов и добавляем многоточие
        temp = temp.substring(0, 12) + '...';
      }
      return temp;
    },

    isImageFile(filename) {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'tiff', 'jfif'];
      const extension = filename.split('.').pop().toLowerCase();
      return imageExtensions.includes(extension);
    }
  },

  watch: {
    'selected.id': (val) => {
      // console.log('new id', val);
      window.$('.lead-editor select.select-custom').selectpicker('destroy');
      setInterval(() => { window.$('.lead-editor select.select-custom').selectpicker(); }, 100);
      // nextTick(() => {
      // });
    }
  }
}
</script>

<style>
.image-fields img {
  max-width: 300px;
  display: inline-block;
  vertical-align: top;
  margin: 0 5px;
}

.image.bg {
  width: 100%;
  /* Ширина элемента */

  /* Высота элемента */
  background-size: cover;
  /* Растягивает изображение, чтобы оно полностью покрывало фон */
  background-position: center;
  /* Центрирует изображение по горизонтали и вертикали */
}
</style>